import { ProductsTFunction } from '@retail/products/i18n';
import dayjs from 'dayjs';
import * as yup from 'yup';

const today = new Date();

export const dateRangeSchema = (t: ProductsTFunction) =>
  yup.object({
    fromDate: yup
      .date()
      .default(new Date())
      .required(t('products.mgItem.fromDate.validation.required'))
      .min(dayjs(today).subtract(1, 'day').toDate(), t('products.mgItem.fromDate.validation.min')),
    toDate: yup.date().default(null).nullable().optional(),
  });

export type DateRangeSchema = yup.InferType<ReturnType<typeof dateRangeSchema>>;
